import { ProcedureEnum } from '@core/procedure-helpers/models/procedure.enum';
import { RxTemplate } from './rx-template.model';

export const deepMerge = <T>(base: T, override: Partial<T>): T => {
	const result = { ...base };

	for (const key of Object.keys(override) as (keyof T)[]) {
		const overrideValue = override[key];
		const baseValue = base[key];

		if (overrideValue !== null && typeof overrideValue === 'object' && !Array.isArray(overrideValue)) {
			result[key] = deepMerge(baseValue as object, overrideValue as object) as T[keyof T];
		} else if (overrideValue !== undefined) {
			result[key] = overrideValue as T[keyof T];
		}
	}

	return result;
};

export const deepFreeze = <T>(obj: T): Readonly<T> => {
	Object.freeze(obj);

	for (const value of Object.values(obj as object)) {
		if (value !== null && typeof value === 'object' && !Object.isFrozen(value)) {
			deepFreeze(value);
		}
	}

	return obj as Readonly<T>;
};

/**
 * Returns true if the procedure type control is hidden by the given template.
 * Used to skip TypeId validation when the field is not shown to the user.
 */
export const isProcedureTypeHiddenByTemplate = (procedureId: ProcedureEnum | null | undefined, { ui }: Readonly<RxTemplate>): boolean => {
	switch (procedureId) {
		case ProcedureEnum.Appliance:
			return !!ui.appliance?.items.procedureType?.hidden;
		case ProcedureEnum.ImplantPlanning:
			return !!ui.implantPlanning?.items.procedureType?.hidden;
		case ProcedureEnum.Denture_Removable:
			return !!ui.denture?.items.procedureType?.hidden;
		case ProcedureEnum.StudyModel_iRecord:
			return !!ui.scanOptions?.items.procedureType?.hidden;
		default:
			return false;
	}
};
